/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/routes/__root'
import { Route as AuthenticatedRouteImport } from './../../pages/routes/_authenticated'
import { Route as IndexRouteImport } from './../../pages/routes/index'
import { Route as PaymentSuccessRouteImport } from './../../pages/routes/payment/success'
import { Route as PaymentResultRouteImport } from './../../pages/routes/payment/result'
import { Route as PaymentCallbackRouteImport } from './../../pages/routes/payment/callback'
import { Route as AuthenticatedReserveRouteImport } from './../../pages/routes/_authenticated/reserve'
import { Route as AuthenticatedMyinfoRouteImport } from './../../pages/routes/_authenticated/myinfo'
import { Route as AuthenticatedApplyIndexRouteImport } from './../../pages/routes/_authenticated/apply/index'
import { Route as AuthenticatedApplySuccessRouteImport } from './../../pages/routes/_authenticated/apply/success'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
  id: '/payment/success',
  path: '/payment/success',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentResultRoute = PaymentResultRouteImport.update({
  id: '/payment/result',
  path: '/payment/result',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentCallbackRoute = PaymentCallbackRouteImport.update({
  id: '/payment/callback',
  path: '/payment/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedReserveRoute = AuthenticatedReserveRouteImport.update({
  id: '/reserve',
  path: '/reserve',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyinfoRoute = AuthenticatedMyinfoRouteImport.update({
  id: '/myinfo',
  path: '/myinfo',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApplyIndexRoute = AuthenticatedApplyIndexRouteImport.update({
  id: '/apply/',
  path: '/apply/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApplySuccessRoute =
  AuthenticatedApplySuccessRouteImport.update({
    id: '/apply/success',
    path: '/apply/success',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/myinfo': typeof AuthenticatedMyinfoRoute
  '/reserve': typeof AuthenticatedReserveRoute
  '/payment/callback': typeof PaymentCallbackRoute
  '/payment/result': typeof PaymentResultRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/apply/success': typeof AuthenticatedApplySuccessRoute
  '/apply/': typeof AuthenticatedApplyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/myinfo': typeof AuthenticatedMyinfoRoute
  '/reserve': typeof AuthenticatedReserveRoute
  '/payment/callback': typeof PaymentCallbackRoute
  '/payment/result': typeof PaymentResultRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/apply/success': typeof AuthenticatedApplySuccessRoute
  '/apply': typeof AuthenticatedApplyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/myinfo': typeof AuthenticatedMyinfoRoute
  '/_authenticated/reserve': typeof AuthenticatedReserveRoute
  '/payment/callback': typeof PaymentCallbackRoute
  '/payment/result': typeof PaymentResultRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/_authenticated/apply/success': typeof AuthenticatedApplySuccessRoute
  '/_authenticated/apply/': typeof AuthenticatedApplyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/myinfo'
    | '/reserve'
    | '/payment/callback'
    | '/payment/result'
    | '/payment/success'
    | '/apply/success'
    | '/apply/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/myinfo'
    | '/reserve'
    | '/payment/callback'
    | '/payment/result'
    | '/payment/success'
    | '/apply/success'
    | '/apply'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/myinfo'
    | '/_authenticated/reserve'
    | '/payment/callback'
    | '/payment/result'
    | '/payment/success'
    | '/_authenticated/apply/success'
    | '/_authenticated/apply/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PaymentCallbackRoute: typeof PaymentCallbackRoute
  PaymentResultRoute: typeof PaymentResultRoute
  PaymentSuccessRoute: typeof PaymentSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/success': {
      id: '/payment/success'
      path: '/payment/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof PaymentSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/result': {
      id: '/payment/result'
      path: '/payment/result'
      fullPath: '/payment/result'
      preLoaderRoute: typeof PaymentResultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/callback': {
      id: '/payment/callback'
      path: '/payment/callback'
      fullPath: '/payment/callback'
      preLoaderRoute: typeof PaymentCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/reserve': {
      id: '/_authenticated/reserve'
      path: '/reserve'
      fullPath: '/reserve'
      preLoaderRoute: typeof AuthenticatedReserveRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/myinfo': {
      id: '/_authenticated/myinfo'
      path: '/myinfo'
      fullPath: '/myinfo'
      preLoaderRoute: typeof AuthenticatedMyinfoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/apply/': {
      id: '/_authenticated/apply/'
      path: '/apply'
      fullPath: '/apply/'
      preLoaderRoute: typeof AuthenticatedApplyIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/apply/success': {
      id: '/_authenticated/apply/success'
      path: '/apply/success'
      fullPath: '/apply/success'
      preLoaderRoute: typeof AuthenticatedApplySuccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedMyinfoRoute: typeof AuthenticatedMyinfoRoute
  AuthenticatedReserveRoute: typeof AuthenticatedReserveRoute
  AuthenticatedApplySuccessRoute: typeof AuthenticatedApplySuccessRoute
  AuthenticatedApplyIndexRoute: typeof AuthenticatedApplyIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedMyinfoRoute: AuthenticatedMyinfoRoute,
  AuthenticatedReserveRoute: AuthenticatedReserveRoute,
  AuthenticatedApplySuccessRoute: AuthenticatedApplySuccessRoute,
  AuthenticatedApplyIndexRoute: AuthenticatedApplyIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PaymentCallbackRoute: PaymentCallbackRoute,
  PaymentResultRoute: PaymentResultRoute,
  PaymentSuccessRoute: PaymentSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
